import * as React from 'react'
import { DVString } from 'DVWebNodeUtils'
import { Text as DVStringProcessor, IconType, Icon, BaseComponentProps, WarningAlert } from 'DVWebNodeUI'
import * as styles from './Infobox.module.scss';
import * as cn from 'classnames'

export interface InfoboxProps extends BaseComponentProps {
    message: DVString
    type?: string
}

export const Infobox = (props: InfoboxProps) => {
    const preIcon = !Boolean(props.type) ? <Icon use={IconType.ENTITLED_TICK} className={styles.customIcon} /> : <></>
    const processedString = <DVStringProcessor string={props.message} className={styles.text} />
    const wrappedIfWarning = props.type == "warn" ? <WarningAlert>{processedString}</WarningAlert> : processedString
    return (<div className={cn(styles.Infobox, props.className)} >
        {preIcon}
        {wrappedIfWarning}
    </div>)
}